export const GET_REPORT_COMPANIES = Symbol('GET_REPORT_COMPANIES');
export const GET_REPORT_COMPANIES_REQUEST = Symbol('GET_REPORT_COMPANIES_REQUEST');
export const GET_REPORT_COMPANIES_SUCCESS = Symbol('GET_REPORT_COMPANIES_SUCCESS');
export const GET_REPORT_COMPANIES_ERROR = Symbol('GET_REPORT_COMPANIES_ERROR');

